import React from 'react';
import { Tooltip } from '@material-ui/core';
import { CheckCircle, Cancel, Schedule, WatchLater } from '@material-ui/icons';
import { STATUS_LABELS } from '../../utils/status';
import PlaneIcon from './PlaneIcon';
import { BLUE } from '../../AnalyticsV2.styled';

// A paper plane with a small badge, as in the design.
const STATUS_ICONS = {
  sent: { color: BLUE, Badge: CheckCircle },
  scheduled: { color: '#C99A00', Badge: Schedule },
  sending: { color: '#5EAB00', Badge: WatchLater },
  cancelled: { color: '#1c1c1c', Badge: Cancel },
};

const StatusCell = ({ message }) => {
  const { color, Badge } = STATUS_ICONS[message.status];

  return (
    <Tooltip title={STATUS_LABELS[message.status]}>
      <PlaneIcon color={color} Badge={Badge} />
    </Tooltip>
  );
};

export default StatusCell;
